import React, { Component } from "react";
import { connect } from "react-redux";

import { Card, Table, Tooltip, Input, Button, Select, Modal } from "antd";

import { getSSPAcademicYear } from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import {
  req_page_ssp_school_source_main,
  req_downloadfile_ssp_source_school_main,
} from "../../api";
import StudentSourceDetail from "./student-source-details";
import SourceSchoolInfoModal from "./source-school-info-modal";
import StudentsNowInfoModal from "./students-now-info-modal";
import StudentSourceItemModal from "./student-source-item-modal";

class StudentSourceEditList extends Component {
  state = {
    loading: false,
    planAcademicYear: getSSPAcademicYear(new Date()),
    countyCityName: "NONE",
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    items: [],
    rows: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",
    cluster: "",
    isShowModal: false,
    isSourceSchoolModal: false,
    isStudentsNowModal: false,
    isStudentSourceItemModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  componentWillUnmount() {
    //window.removeEventListener("resize", this.resize.bind(this))
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      planAcademicYear,
      countyCityName,
    } = this.state;
    const { token, role, userCode } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ loading: true, userLevel: userLevel });
    const result = await req_page_ssp_school_source_main(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      planAcademicYear,
      countyCityName,
      token
    );
    this.setState({ loading: false });
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(items);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_page_item_noLoad = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      planAcademicYear,
      countyCityName,
    } = this.state;
    const { token, role, userCode } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_page_ssp_school_source_main(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      planAcademicYear,
      countyCityName,
      token
    );
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(items);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      planAcademicYear,
      countyCityName,
    } = this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_downloadfile_ssp_source_school_main(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      planAcademicYear,
      countyCityName,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (sorter) {
        console.log(sorter);
        const { field, order } = sorter;
        //"ascend" 多, descend "少"
        this.setState({
          columnSort: field,
          orderBy: order,
        });
      } else {
        this.setState({
          columnSort: "NA",
          orderBy: SORT_UP_DOWN,
        });
      }
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true });
        break;
      case "SourceSchoolInfo":
        this.setState({ isSourceSchoolModal: true, item });
        break;
      case "SchoolStudentNow":
        //console.log(item);
        this.setState({ isStudentsNowModal: true, item });
        break;
      case "NumberOfPeopleTotalAA":
        this.setState({ isStudentSourceItemModal: true, cluster: "AA", item });
        break;
      case "NumberOfPeopleTotalAB":
        this.setState({ isStudentSourceItemModal: true, cluster: "AB", item });
        break;
      case "NumberOfPeopleTotalAC":
        this.setState({ isStudentSourceItemModal: true, cluster: "AC", item });
        break;
      case "NumberOfPeopleTotalAD":
        this.setState({ isStudentSourceItemModal: true, cluster: "AD", item });
        break;
      case "NumberOfPeopleTotalAE":
        this.setState({ isStudentSourceItemModal: true, cluster: "AE", item });
        break;
      case "NumberOfPeopleTotalF":
        this.setState({ isStudentSourceItemModal: true, cluster: "AF", item });
        break;
      case "NumberOfPeopleTotalAG":
        this.setState({ isStudentSourceItemModal: true, cluster: "AG", item });
        break;
      case "NumberOfPeopleTotalAH":
        this.setState({ isStudentSourceItemModal: true, cluster: "AH", item });
        break;
      case "NumberOfPeopleTotalAI":
        this.setState({ isStudentSourceItemModal: true, cluster: "AI", item });
        break;
      case "NumberOfPeopleTotalAJ":
        this.setState({ isStudentSourceItemModal: true, cluster: "AJ", item });
        break;
      case "NumberOfPeopleTotalAK":
        this.setState({ isStudentSourceItemModal: true, cluster: "AK", item });
        break;
      case "NumberOfPeopleTotalAM":
        this.setState({ isStudentSourceItemModal: true, cluster: "AM", item });
        break;
      case "NumberOfPeopleTotalAN":
        this.setState({ isStudentSourceItemModal: true, cluster: "AN", item });
        break;
      case "NumberOfPeopleTotalAO":
        this.setState({ isStudentSourceItemModal: true, cluster: "AO", item });
        break;
      case "NumberOfPeopleTotalAP":
        this.setState({ isStudentSourceItemModal: true, cluster: "AP", item });
        break;
      case "NumberOfPeopleTotalAQ":
        this.setState({ isStudentSourceItemModal: true, cluster: "AQ", item });
        break;
      case "NumberOfPeopleTotalAR":
        this.setState({ isStudentSourceItemModal: true, cluster: "AR", item });
        break;
      case "NumberOfPeopleTotalAX":
        this.setState({ isStudentSourceItemModal: true, cluster: "AX", item });
        break;
      case "NumberOfPeopleTotalAY":
        this.setState({ isStudentSourceItemModal: true, cluster: "AY", item });
        break;
      case "NumberOfPeopleTotalAZ":
        this.setState({ isStudentSourceItemModal: true, cluster: "AZ", item });
        break;
      case "download":
        this.api_downloadfile_items();
        break;
      default:
    }
  };

  handle_expanded = (expandedRows) => {
    //console.log(expandedRows);
    if (!expandedRows) {
      this.handle_data_refresh();
    }
  };

  refreshdata = () => {
    //console.log("refreshdata");
    this.api_page_item_noLoad(this.current);
  };

  /////////////////////////////////////////////////////////////
  init_columns = () => {
    const { planAcademicYear } = this.state;
    this.columns = [
      {
        title: "地區",
        dataIndex: "CountyCityName",
        width: 45,
        align: "center",
        fixed: "left",
        render: (field) => {
          return (
            <>
              <span style={{ fontWeight: 900 }}> {field}</span>
            </>
          );
        },
      },
      {
        title: "來源學校",
        width: 120,
        fixed: "left",
        render: (item) => {
          const { HighSchoolTwName } = item;
          return (
            <>
              <button
                className="btn btn-outline-dark btn-sm"
                style={{ width: "100%", fontWeight: 900 }}
                onClick={() =>
                  this.handle_show_ui_modal("SourceSchoolInfo", item)
                }
              >
                {HighSchoolTwName}
              </button>
            </>
          );
        },
      },
      {
        title: () => {
          return <>{planAcademicYear - 1 + "年註冊"}</>;
        },
        dataIndex: "EnrolledStudentTotal",
        width: 45,
        align: "right",
        fixed: "left",
        sorter: "EnrolledStudentTotal",
        render: (text, record) => {
          return (
            <div>
              {" "}
              <button
                className={
                  parseInt(text) > 0
                    ? "btn btn-outline-success btn-sm"
                    : "btn btn-light btn-sm"
                }
                disabled={parseInt(text) > 0 ? false : true}
                style={{ width: "100%", fontWeight: 900 }}
                onClick={() =>
                  this.handle_show_ui_modal("SchoolStudentNow", record)
                }
              >
                {text}
              </button>
            </div>
          );
        },
      },
      {
        title: "規劃總額",
        dataIndex: "PlanStudentTotal",
        width: 45,
        align: "center",
        fixed: "left",
        sorter: "PlanStudentTotal",
        render(text, record) {
          return {
            props: {
              style: {
                background: parseInt(text) > 0 ? "#FFD700" : "#FFFFFF",
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "商管群",
        dataIndex: "NumberOfPeopleTotalAA",
        width: 40,
        align: "right",
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAA", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "餐旅群",
        dataIndex: "NumberOfPeopleTotalAB",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAB", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "設計群",
        dataIndex: "NumberOfPeopleTotalAC",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAC", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "藝術群",
        dataIndex: "NumberOfPeopleTotalAD",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAD", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "機械群",
        dataIndex: "NumberOfPeopleTotalAE",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAE", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "食品群",
        dataIndex: "NumberOfPeopleTotalAF",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAF", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "土木群",
        dataIndex: "NumberOfPeopleTotalAG",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAG", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "外語群英語類",
        dataIndex: "NumberOfPeopleTotalAH",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAH", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "電子與電機群資電類",
        dataIndex: "NumberOfPeopleTotalAI",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAI", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "家政群生活應用類",
        dataIndex: "NumberOfPeopleTotalAJ",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAJ", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "家政群幼保類",
        dataIndex: "NumberOfPeopleTotalAK",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAK", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "農業類",
        dataIndex: "NumberOfPeopleTotalAM",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAM", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: <>藝術 單招</>,
        dataIndex: "NumberOfPeopleTotalAN",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAN", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: <>繁星 運優</>,
        dataIndex: "NumberOfPeopleTotalAX",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAX", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: <>申請 技優</>,
        dataIndex: "NumberOfPeopleTotalAY",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAY", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
      {
        title: "其他",
        dataIndex: "NumberOfPeopleTotalAZ",
        align: "right",
        width: 40,
        render: (text, record) => {
          return (
            <div>
              {parseInt(text) > 0 ? (
                <button
                  className={
                    parseInt(text) > 0
                      ? "btn btn btn-outline-info btn-sm"
                      : "btn btn-light btn-sm"
                  }
                  disabled={parseInt(text) > 0 ? false : true}
                  style={{ width: "100%" }}
                  onClick={() =>
                    this.handle_show_ui_modal("NumberOfPeopleTotalAZ", record)
                  }
                >
                  {parseInt(text) > 0 ? text : ""}
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
    ];
  };

  render() {
    const {
      loading,
      cluster,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      planAcademicYear,
      countyCityName,
      isSourceSchoolModal,
      isStudentsNowModal,
      isStudentSourceItemModal,
    } = this.state;

    const title = (
      <>
        <span>規劃年度</span>
        <Input
          placeholder="規劃年度"
          style={{
            width: 55,
            height: 39,
            margin: "0 5px",
            color: "red",
          }}
          onChange={(event) =>
            this.setState({ planAcademicYear: event.target.value })
          }
          value={planAcademicYear}
          readOnly={true}
          disabled={true}
        />
        <Select
          value={countyCityName}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ countyCityName: value })}
        >
          <Select.Option value="NONE" key="NONE">
            縣市
          </Select.Option>
          <Select.Option value="臺北市" key="臺北市">
            臺北市
          </Select.Option>
          <Select.Option value="新北市" key="新北市">
            新北市
          </Select.Option>
          <Select.Option value="基隆市" key="基隆市">
            基隆市
          </Select.Option>
          <Select.Option value="宜蘭縣" key="宜蘭縣">
            宜蘭縣
          </Select.Option>
          <Select.Option value="花蓮縣" key="花蓮縣">
            花蓮縣
          </Select.Option>
          <Select.Option value="臺東縣" key="臺東縣">
            臺東縣
          </Select.Option>
          <Select.Option value="桃園市" key="桃園市">
            桃園市
          </Select.Option>
          <Select.Option value="新竹市" key="新竹市">
            新竹市
          </Select.Option>
          <Select.Option value="新竹縣" key="新竹縣">
            新竹縣
          </Select.Option>
          <Select.Option value="苗栗縣" key="苗栗縣">
            苗栗縣
          </Select.Option>
          <Select.Option value="臺中市" key="臺中市">
            臺中市
          </Select.Option>
          <Select.Option value="彰化縣" key="彰化縣">
            彰化縣
          </Select.Option>
          <Select.Option value="南投縣" key="南投縣">
            南投縣
          </Select.Option>
          <Select.Option value="雲林縣" key="雲林縣">
            雲林縣
          </Select.Option>
          <Select.Option value="嘉義市" key="嘉義市">
            嘉義市
          </Select.Option>
          <Select.Option value="嘉義縣" key="嘉義縣">
            嘉義縣
          </Select.Option>
          <Select.Option value="臺南市" key="臺南市">
            臺南市
          </Select.Option>
          <Select.Option value="高雄市" key="高雄市">
            高雄市
          </Select.Option>
          <Select.Option value="屏東縣" key="屏東縣">
            屏東縣
          </Select.Option>
          <Select.Option value="金門縣" key="金門縣">
            金門縣
          </Select.Option>
          <Select.Option value="連江縣" key="連江縣">
            連江縣
          </Select.Option>
          <Select.Option value="澎湖縣" key="澎湖縣">
            澎湖縣
          </Select.Option>
        </Select>
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">其他條件</Select.Option>
          <Select.Option value="HighSchoolTwName">生源學校校名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{
            width: 100,
            height: 32,
            margin: "0 5px",
            backgroundColor: "LightYellow",
          }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("download", {})}
          style={{ marginLeft: "4px" }}
        >
          <i className="fas fa-cloud-download-alt element-hidden"></i> 下載
        </Button>
      </>
    );

    const expandedRowRender = (row) => {
      const { HighSchoolCode, NowYearMonth } = row;
      const { planAcademicYear } = this.state;
      return (
        <StudentSourceDetail
          schoolcode={HighSchoolCode}
          planAcademicYear={planAcademicYear}
          yearMonth={NowYearMonth}
          refreshdata={this.refreshdata}
        ></StudentSourceDetail>
      );
    };
    return (
      <>
        <Card title={title}>
          <Table
            bordered
            scroll={{ y: 400, x: 800 }}
            loading={loading}
            rowKey="Id"
            dataSource={items}
            onChange={this.handle_table_change}
            expandable={{
              columnWidth: "10px",
              expandedRowRender,
              onExpandedRowsChange: this.handle_expanded,
            }}
            pagination={{
              ...pagination,
              size: "small",
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [5, 10, 20, 50, 100],
              onShowSizeChange: this.handle_page_size_change,
            }}
            columns={this.columns}
          />
        </Card>
        <Modal
          destroyOnClose={true}
          visible={isSourceSchoolModal}
          width={"85%"}
          onOk={() => {
            this.setState({ isSourceSchoolModal: false });
            // this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isSourceSchoolModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SourceSchoolInfoModal item={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isStudentsNowModal}
          width={"85%"}
          onOk={() => {
            this.setState({ isStudentsNowModal: false });
            // this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isStudentsNowModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <StudentsNowInfoModal item={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isStudentSourceItemModal}
          width={"85%"}
          onOk={() => {
            this.setState({ isStudentSourceItemModal: false });
            // this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isStudentSourceItemModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <StudentSourceItemModal item={item} cluster={cluster} />
        </Modal>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(StudentSourceEditList);
